const PLACEHOLDER_VALUES = ['Pending', 'Setup', '—'];

export const asEmptyIfPlaceholder = (v) => {
  const s = (v ?? '').trim();
  return PLACEHOLDER_VALUES.includes(s) ? '' : (v ?? '');
};

const PROFILE_FORM_KEYS = [
  'first_name', 'last_name', 'job_title', 'company_name', 'email', 'mobile_phone',
  'secondary_phone', 'brand_supplier_name', 'address_line_1', 'address_line_2', 'address_line_3',
  'town_city', 'postcode', 'country',
  'ship_from_same_as_address',
  'ship_from_address_line_1', 'ship_from_address_line_2', 'ship_from_address_line_3',
  'ship_from_town_city', 'ship_from_postcode', 'ship_from_country',
];

const OPTIONAL_STRING_KEYS = new Set([
  'secondary_phone', 'address_line_2', 'address_line_3',
  'ship_from_address_line_2', 'ship_from_address_line_3',
]);

export const profileToFormState = (profile, asEmpty = asEmptyIfPlaceholder) => {
  if (!profile) return null;
  const state = {};
  for (const key of PROFILE_FORM_KEYS) {
    const v = profile[key];
    if (key === 'ship_from_same_as_address') {
      state[key] = v === false ? false : true;
      continue;
    }
    state[key] = OPTIONAL_STRING_KEYS.has(key)
      ? (v ?? '')
      : asEmpty(v);
  }
  return state;
};
